import React from 'react';
import { withUnpublishedPreview } from 'gatsby-source-prismic';

import Layout from '../components/layout';
import SEO from '../components/seo';

import Company from '../templates/company';
import BasicPage from '../templates/basic-page';

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <h1>404: Not Found</h1>
    <p>You just hit a route that doesn't exist</p>
  </Layout>
);

export default withUnpublishedPreview(NotFoundPage, {
  templateMap: {
    company: Company,
    basic_page: BasicPage,
  },
});
